// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","nav":"Header_nav__J8WFt","nav1":"Header_nav1__GsF-S","navLink":"Header_navLink__jN4KB","active":"Header_active__rHuVo","hi":"Header_hi__qY3Ng"};